import { Order } from "./interfaces"

export const toTableRowItems = (items: Order[]) =>
  items.map((item: Order) => ({
    id: item.id,
    orderNumber: item.orderNumber,
    supplierCode: item.supplierCode,
    supplierName: item.supplierName || '',
    orderStatus: item.orderStatus,
    orderStatusDescription: item.orderStatusDescription || '',
    rayonName: item.rayonName || '',
    shopCode: item.shopCode || '',
    dsDeliveryStatus: item.dsDeliveryStatus || '',
    deliveryDate: item.deliveryDate || '',
    deliveryHour: item.deliveryHour || '',
    expectedDeliveryDate: item.expectedDeliveryDate || '',
    dsDeliveryStatusValue: item.dsDeliveryStatusValue || '',
    orderDate: item.orderDate || '',
    temperatureComplaint: item.temperatureComplaint || '',
    noticeNumber: item.noticeNumber || '',
    arrivalTemperature: item.arrivalTemperature,
    productsProcessedTime: item.productsProcessedTime
  }))
